import type { FC } from 'react'
import { lazy, Suspense, useState } from 'react'

import type { ReplyFormProps } from './types'

// Lazy so the Lexical bundle is only fetched when a reply form actually
// renders (request-changes flow) — keeps it out of the initial load on this
// public site (SKE-3792).
const CommentEditor = lazy(() => import('ui/sked-editor/comment-editor'))

const ReplyForm: FC<ReplyFormProps> = ({
  postId,
  isSubmitting,
  isMobile,
  onSubmit,
  lastMessageId,
  autoFocus = true,
  collaborators,
}) => {
  const [replyMessage, setReplyMessage] = useState('')
  // Bump to force a fresh (empty) editor instance after a successful submit.
  const [editorKey, setEditorKey] = useState(0)

  const handleSubmit = () => {
    const trimmed = replyMessage.trim()
    if (postId && trimmed && lastMessageId) {
      onSubmit(trimmed, lastMessageId)
      setReplyMessage('')
      setEditorKey((key) => key + 1)
    }
  }

  return (
    <div
      className="w-full rounded-b-[8px] bg-red-50 p-[8px] lg:max-w-[360px]"
      onClick={(e) => e.stopPropagation()} // mobile: don't toggle the card
    >
      <Suspense
        fallback={
          <div className="h-[64px] w-full animate-pulse rounded-[8px] bg-white" />
        }
      >
        <CommentEditor
          key={editorKey}
          postId={postId}
          collaborators={collaborators}
          placeholder="Enter feedback"
          onChange={setReplyMessage}
          onSubmit={handleSubmit}
          disabled={isSubmitting}
          autoFocus={!isMobile && autoFocus}
        />
      </Suspense>
      <button
        type="button"
        disabled={isSubmitting || !replyMessage.trim()}
        onClick={(e) => {
          e.stopPropagation()
          handleSubmit()
        }}
        className="ml-auto mt-[12px] flex cursor-pointer items-center justify-center rounded-[8px] border-none bg-[#fa4f38] px-[26px] py-[7px] text-[12px] font-[600] text-white disabled:cursor-wait disabled:opacity-70"
      >
        Send
      </button>
    </div>
  )
}

export default ReplyForm
